import React, { useState } from "react";
import AlphaWhyManagedModal from "./AlphaWhyManagedModal";

interface AlphaManagedNudgeProps {
  onAdopt?: (managedProductId: number) => void;
}

// Compact header entry point for the existing Plutus Managed explainer. The
// allocation editor owns visibility and adoption updates its existing draft;
// this component never creates another editing surface.
const AlphaManagedNudge: React.FC<AlphaManagedNudgeProps> = ({ onAdopt }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        data-testid="alpha-managed-nudge"
        className="flex max-w-full items-center gap-2.5 rounded-v7-control border border-v7-bronze/30 bg-v7-paper px-2.5 py-1.5 sm:px-3"
      >
        <img
          data-testid="alpha-managed-nudge-logo"
          src="/favicon.png"
          alt=""
          aria-hidden="true"
          className="h-7 w-7 shrink-0 object-contain"
        />
        <p className="min-w-0 text-xs font-medium leading-4 text-v7-ink sm:text-[13px] sm:leading-5">
          Prefer Plutus to manage it for you?
        </p>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="inline-flex min-h-9 shrink-0 items-center border-b border-v7-bronze-dark/40 text-xs font-semibold text-v7-bronze-dark transition-colors hover:border-v7-ink hover:text-v7-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-v7-bronze-dark sm:text-[13px]"
        >
          Learn more
        </button>
      </div>

      <AlphaWhyManagedModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        showAdopt={Boolean(onAdopt)}
        onAdopt={onAdopt}
      />
    </>
  );
};

export default AlphaManagedNudge;
